export function setDateStatus() {
	const tripDates = document.querySelectorAll("[trip-date-text~='status']");
	tripDates.forEach((tripDate) => {
		const status = tripDate.innerText.toLowerCase();
		const sibling = tripDate.nextElementSibling;
		const matchedElement = sibling.querySelector(`[js-set-status~='${status}']`);

		// Check if matchedElement is not null before trying to access its classList property
		if (matchedElement) {
			matchedElement.classList.add("show");
		} else {
			console.warn(`No element found for status '${status}'`);
		}
	});
}
